// ✅ VERSION LENGKAP Register.js dengan handleRegister() + secretCode
import React, { useState } from "react";
import {
    setDoc,
    doc,
    updateDoc,
    arrayUnion,
    collection,
    Timestamp,
    query,
    where,
    getDocs,

} from "firebase/firestore";
import { db, auth } from "../services/firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";

import { getClassroomsForSchool } from "../services/firestoreService";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import {
    STATE_OPTIONS,
    generateUserId,
    generateSchoolId,
    toTitleCase,
    customStyles
} from "../utils/commonUtils";




const Register = () => {
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [role, setRole] = useState("teacher");
    const [newSchoolMode, setNewSchoolMode] = useState(false);
    const [newSchoolName, setNewSchoolName] = useState("");
    const [newSchoolAddress, setNewSchoolAddress] = useState("");
    const [newTeacherPhone, setnewTeacherPhone] = useState("");
    const [newSchoolState, setNewSchoolState] = useState("");
    const [customSchoolCode, setCustomSchoolCode] = useState(""); // now it's secretCode
    const [schoolCode, setSchoolCode] = useState("");
    const [matchedSchool, setMatchedSchool] = useState(null);
    const [schoolCheckError, setSchoolCheckError] = useState("");
    const [canShowForm, setCanShowForm] = useState(false);
    const [classOptions, setClassOptions] = useState([]);
    const [selectedClass, setSelectedClass] = useState(null);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    const handleCheckSchool = async () => {
        setSchoolCheckError("");
        setMatchedSchool(null);
        setCanShowForm(false);

        if (!schoolCode) {
            setSchoolCheckError("Sila masukkan kod sekolah.");
            return;
        }

        const q = query(collection(db, "schools"), where("secretCode", "==", schoolCode));
        const snapshot = await getDocs(q);

        if (snapshot.empty) {
            if (role === "teacher") setNewSchoolMode(true);
            setSchoolCheckError(
                "Kod sekolah tidak ditemui. Anda boleh daftar sekolah baru."
            );
            return;
        }

        const schoolDoc = snapshot.docs[0];
        const data = schoolDoc.data();

        if (!data.approved) {
            setSchoolCheckError("Sekolah telah dijumpai tetapi belum diluluskan oleh admin.");
            return;
        }

        setMatchedSchool({ ...data, id: schoolDoc.id });
        setCanShowForm(true);

        const classData = await getClassroomsForSchool(schoolDoc.id);
        const formatted = classData.map((cls) => ({ value: cls.id, label: cls.name }));
        setClassOptions(formatted);
    };

    const handleStudentClassChange = (selectedOption) => {
        setSelectedClass(selectedOption ? selectedOption.value : null);
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");

        if (!name || !email || !password) {
            setError("Sila isi semua maklumat wajib.");
            return;
        }

        try {
            // 1) Create auth user
            const cred = await createUserWithEmailAndPassword(auth, email, password);
            const uid = cred.user.uid;

            // 2) Optional: ID cantik untuk display
            const userCode = generateUserId(role, name);

            if (newSchoolMode) {
                // === DAFTAR SEKOLAH BARU (GURU) ===
                if (
                    !newSchoolName ||
                    !newSchoolAddress ||
                    !newSchoolState ||
                    !newTeacherPhone ||
                    !customSchoolCode
                ) {
                    setError("Sila isi semua maklumat sekolah baru.");
                    return;
                }

                const qCode = query(
                    collection(db, "schools"),
                    where("secretCode", "==", customSchoolCode)
                );
                const snapshot = await getDocs(qCode);
                if (!snapshot.empty) {
                    setError("Kod sekolah ini telah digunakan. Sila pilih kod lain.");
                    return;
                }

                const newId = generateSchoolId(newSchoolState, newSchoolName);

                await setDoc(doc(db, "schools", newId), {
                    id: newId,
                    secretCode: customSchoolCode,
                    name: newSchoolName,
                    address: newSchoolAddress,
                    negeri: newSchoolState,
                    phone: newTeacherPhone,
                    createdAt: Timestamp.now(),
                    createdBy: email,
                    approved: false,
                });

                await setDoc(doc(db, "users", uid), {
                    id: uid,
                    userCode, // ID cantik
                    name,
                    email,
                    role: "teacher",
                    approved: false,
                    schools: [
                        {
                            schoolId: newId,
                            isAdmin: false,
                            isApproved: false,
                        },
                    ],
                    createdAt: Timestamp.now(),
                });
            } else {
                // === SEKOLAH SEDIA ADA ===
                if (role === "student") {
                    if (!matchedSchool || !selectedClass) {
                        setError("Sila pilih kelas terlebih dahulu.");
                        return;
                    }

                    await setDoc(doc(db, "users", uid), {
                        id: uid,
                        userCode,
                        name,
                        email,
                        role: "student",
                        schoolId: matchedSchool.id,
                        classroomId: selectedClass,
                        isApproved: false,
                        createdAt: Timestamp.now(),
                    });

                    await updateDoc(
                        doc(db, "schools", matchedSchool.id, "classrooms", selectedClass),
                        {
                            pendingStudents: arrayUnion(uid),
                        }
                    );
                } else if (role === "teacher") {
                    if (!matchedSchool) {
                        setError("Sila semak dan sahkan kod sekolah terlebih dahulu.");
                        return;
                    }

                    await setDoc(doc(db, "users", uid), {
                        id: uid,
                        userCode,
                        name,
                        email,
                        role: "teacher",
                        approved: false,
                        schools: [
                            {
                                schoolId: matchedSchool.id,
                                isAdmin: false,
                                isApproved: false,
                            },
                        ],
                        createdAt: Timestamp.now(),
                    });

                    console.log(
                        "👨‍🏫 Guru berjaya didaftarkan pada sekolah sedia ada:",
                        matchedSchool.id
                    );
                }
            }

            setSuccess("Pendaftaran berjaya! Sila tunggu kelulusan admin.");
            navigate("/registration-complete");
        } catch (err) {
            console.error("Register error:", err);
            if (err.code === "auth/email-already-in-use") {
                setError("Emel ini telah digunakan. Sila guna emel lain.");
            } else if (err.code === "auth/weak-password") {
                setError("Kata laluan terlalu lemah. Sila guna kombinasi yang lebih kuat.");
            } else {
                setError("Pendaftaran gagal. Sila cuba lagi.");
            }
        }
    };


    return (
        <div className="login-container">
            <h1>Daftar</h1>

            <div className="role-selection-container">
                <div className={`option-container ${role === "teacher" ? "active" : ""}`} onClick={() => setRole("teacher")}>
                    <h2>Guru</h2>
                    <p>Uruskan sekolah dan kelas anda</p>
                </div>
                <div className={`option-container ${role === "student" ? "active" : ""}`}
                    onClick={() => {
                        setRole("student");
                        setNewSchoolMode(false);
                        setCanShowForm(false);
                    }}>
                    <h2>Murid</h2>
                    <p>Sertai kelas anda untuk tasmik</p>
                </div>
            </div>

            <div className="input-container">
                <input
                    type="text"
                    placeholder="Masukkan Kod Sekolah"
                    className="input-field"
                    style={{ margin: "24px 0" }}
                    value={schoolCode}
                    onChange={(e) => setSchoolCode(e.target.value.trim().toUpperCase())}
                />
                {role === "teacher" && !newSchoolMode && (
                    <p
                        style={{
                            marginTop: "-10px",
                            marginBottom: "20px",
                            fontSize: "0.9rem",
                            color: "#007bff",
                            cursor: "pointer",
                            textAlign: "center",
                        }}
                        onClick={() => {
                            setNewSchoolMode(true);
                            setCanShowForm(true);
                            setMatchedSchool(null);
                            setSchoolCheckError("");
                        }}
                    >
                        Tiada kod sekolah? <strong>Daftar sekolah baru</strong>
                    </p>
                )}


                <button
                    className={`login-button ${canShowForm ? "btn-white" : ""}`}
                    onClick={handleCheckSchool}
                    type="button"
                >
                    Semak
                </button>
                {matchedSchool && <p style={{ color: "green" }}>Sekolah dijumpai: {matchedSchool.name}</p>}
                {schoolCheckError && <p style={{ color: "red" }}>{schoolCheckError}</p>}
            </div>

            {newSchoolMode && role === "teacher" && !canShowForm && (
                <div style={{ marginBottom: "20px" }}>
                    <button className={`login-button ${!canShowForm ? "btn-white" : ""}`} onClick={() => setCanShowForm(true)}>
                        Borang Daftar
                    </button>
                </div>
            )}


            {canShowForm && (
                <form onSubmit={handleRegister} className="login-form">
                    <div className="input-container">
                        <input
                            type="text"
                            placeholder="Nama"
                            className="input-field"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            onBlur={(e) => setName(toTitleCase(e.target.value))}
                            required
                        />
                    </div>
                    <div className="input-container">
                        <input
                            type="email"
                            placeholder="Emel"
                            className="input-field"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="input-container">
                        <input
                            type="password"
                            placeholder="Katalaluan"
                            className="input-field"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    {role === "student" && (
                        <div className="input-container">
                            <Select
                                options={classOptions}
                                onChange={handleStudentClassChange}
                                value={classOptions.find((opt) => opt.value === selectedClass)}
                                placeholder="Pilih kelas"
                                isClearable
                                isDisabled={!matchedSchool}
                                styles={customStyles}
                            />
                        </div>
                    )}

                    {role === "teacher" && newSchoolMode && (
                        <>
                            <div className="input-container">
                                <input
                                    type="text"
                                    placeholder="Telefon Guru"
                                    className="input-field"
                                    value={newTeacherPhone}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d{0,11}$/.test(value)) {
                                            setnewTeacherPhone(value);
                                        }
                                    }}
                                />

                            </div>
                            <div className="input-container">
                                <input
                                    type="text"
                                    placeholder="Nama Sekolah"
                                    className="input-field"
                                    value={newSchoolName}
                                    onChange={(e) => setNewSchoolName(e.target.value)}
                                    onBlur={(e) => setNewSchoolName(toTitleCase(e.target.value))}
                                />
                            </div>
                            <div className="input-container">
                                <input
                                    type="text"
                                    placeholder="Alamat Sekolah"
                                    className="input-field"
                                    value={newSchoolAddress}
                                    onChange={(e) => setNewSchoolAddress(e.target.value)}
                                    onBlur={(e) => setNewSchoolAddress(toTitleCase(e.target.value))}
                                />
                            </div>
                            <div className="input-container">
                                <Select
                                    options={STATE_OPTIONS}
                                    value={STATE_OPTIONS.find((opt) => opt.value === newSchoolState)}
                                    onChange={(selected) => setNewSchoolState(selected.value)}
                                    placeholder="Pilih negeri"
                                    isClearable
                                    styles={customStyles}
                                />
                            </div>

                            <div className="input-kod">
                                <input
                                    type="text"
                                    placeholder="Kod Sekolah"
                                    className="input-kod-field"
                                    value={customSchoolCode}
                                    maxLength={6}

                                    onChange={(e) => setCustomSchoolCode(e.target.value.trim().toUpperCase())}
                                />
                                <label className="label-kod">Sila cipta 6 aksara kod untuk digunakan oleh guru dan murid semasa pendaftaran</label>
                            </div>
                        </>
                    )}

                    {error && <p className="error-message">{error}</p>}
                    {success && <p style={{ color: "green" }}>{success}</p>}

                    <button type="submit" className="login-button">
                        {newSchoolMode
                            ? "Daftar Sekolah"
                            : role === "teacher"
                                ? "Daftar sebagai Guru"
                                : "Daftar sebagai Murid"}
                    </button>
                </form>
            )}

            <div style={{ padding: "20px 0 0" }}>
                <Link to="/login" className="link">
                    Kembali ke Utama
                </Link>
            </div>
        </div>
    );
};

export default Register;



